import { envHttpUrl } from './globalMethod'

const AUTH_STORAGE_KEYS = [
    'LOGIN_TOKEN',
]

const AUTH_SESSION_KEYS = [
    'portal_api_key_latest_full_key',
]

const AUTH_COOKIE_NAMES = [
    'LECHUNAUTH',
    'secure-lc_auth',
    'lechunoauth',
    'JSESSIONID',
]

const getVisibleCookieNames = () => {
    const raw = document.cookie || ''
    if (!raw.trim()) return []

    return raw
        .split(';')
        .map(item => item.trim().split('=')[0])
        .filter(Boolean)
}

const buildCookieDomainCandidates = () => {
    const hostname = window.location.hostname || ''
    if (!hostname) return []

    const candidates = new Set([
        hostname,
        `.${hostname}`,
    ])
    const parts = hostname.split('.').filter(Boolean)
    for (let i = 1; i < parts.length - 1; i += 1) {
        const domain = parts.slice(i).join('.')
        candidates.add(domain)
        candidates.add(`.${domain}`)
    }
    return Array.from(candidates)
}

const buildCookiePathCandidates = () => {
    const pathname = window.location.pathname || '/'
    const candidates = new Set(['/'])
    const parts = pathname.split('/').filter(Boolean)
    let currentPath = ''
    parts.forEach(part => {
        currentPath += `/${part}`
        candidates.add(currentPath)
        candidates.add(`${currentPath}/`)
    })
    return Array.from(candidates)
}

const expireCookie = (name, path = '/', domain) => {
    let cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=${path}`
    if (domain) {
        cookie += `; domain=${domain}`
    }
    document.cookie = cookie
}

export const clearClientAuthState = () => {
    AUTH_STORAGE_KEYS.forEach(key => window.localStorage.removeItem(key))
    AUTH_SESSION_KEYS.forEach(key => window.sessionStorage.removeItem(key))

    const cookieNames = new Set([...AUTH_COOKIE_NAMES, ...getVisibleCookieNames()])
    const domains = [undefined, ...buildCookieDomainCandidates()]
    const paths = buildCookiePathCandidates()
    cookieNames.forEach(name => {
        domains.forEach(domain => {
            paths.forEach(path => {
                expireCookie(name, path, domain)
            })
        })
    })
}

export const redirectToLogin = () => {
    const returnPage = encodeURIComponent(window.location.href)
    window.location.href = `${window.location.protocol}${envHttpUrl().webUrl}/login?auth=1&returnPage=${returnPage}`
}

export const cleanupAndRedirectToLogin = () => {
    clearClientAuthState()
    redirectToLogin()
}
